import { persistStore, persistReducer } from 'redux-persist';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import rootReducer from '@Bootstraps/bootstrapReducers';

let finalReducer = rootReducer;

const persist = {
    active: true,
    config: {
        key: 'root',
        storage,
        whitelist: ['accessToken', 'cart'],
    },
};

if (persist.active) {
    finalReducer = persistReducer(persist.config, rootReducer);
};

export const sagaMiddleware = createSagaMiddleware();
export const store = createStore(finalReducer, applyMiddleware(sagaMiddleware));
export const persistor = persistStore(store);